<ng-template #contentHeaderTemplate></ng-template>

@if (process) {
  <app-process-tab-switcher [processId]="process.id"></app-process-tab-switcher>

  <app-table
    [replaceParametersInUrl]="{'{process}': process.id}"
    id="dashboard.quality-management.processes.versions.index"
    [defaultSort]="'-version_number'"
  ></app-table>
}
